module.exports = __webpack_public_path__ + "static/media/cancel.b2138751.svg";